class TopFacilityListSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if(isMobile()){
      const modalSwiper = new Swiper("." + this.el, {
        loop: false,
        speed: 1000,
        spaceBetween: 15,
        slidesPerView: 1.2
      });
    }
  }
}
